import axios from 'axios';
import { authTokenWithSC } from 'js/library/utils/API/authWithSecurityCode';
import cfac22 from '../cfac22';

export function authCode(cellPhone, pathname, sendType = { whatsapp: true, email: true, sms: false }) {
  return new Promise((resolve, reject) => {
    authTokenWithSC()
      .then((token) => {
        axios
          .post(
            cfac22('API_HOST_V2') + '/authCode',
            {
              cellphone: cellPhone,
              platform: 'web-app',
              sendType: sendType,
            },
            {
              headers: { authorization: `Bearer ${token}`, 'Full-Url': window.location.href },
            }
          )
          .then((result) => {
            if (result.data.error) {
              reject(result.data.error);
            } else {
              window.pathname = pathname;

              const objReply = {
                cellPhone,
                transactionId: !result.data.error ? result.data.transactionId : null,
                error: result.data.error,
              };

              resolve(objReply);
            }
          })
          .catch((error) => {
            reject(error);
          });
      })
      .catch((error) => {
        reject(error);
      });
  });
}